import { Flex, HStack, Link, LinkBox, LinkOverlay, ListItem, Text } from "@chakra-ui/react"
import React from "react"
import { NavLink } from "react-router-dom"
import { ExtendedPhoneDeviceFragment } from "../../graphql"
import { Stat } from "../common"

export type PhoneDeviceListItemProps = {
	phoneDevice: ExtendedPhoneDeviceFragment
}

export const PhoneDeviceListItem: React.FC<PhoneDeviceListItemProps> = ({ phoneDevice }) => {
	return (
		<ListItem as={LinkBox} _hover={{ bgColor: "blackAlpha.100" }} transition="background-color .1s ease-in" rounded="xl" cursor="pointer">
			<LinkOverlay as={NavLink} to={`/phoneDevices/${phoneDevice._id}`} />
			<HStack w="full" justify="space-between" px="2">
				<Flex flex="1" justify="center" align="center" flexWrap="wrap">
					<Stat label="Name" value={phoneDevice.label.name} />
					<Stat label="ID" value={phoneDevice.deviceId} />
					<Stat label="Status" value={phoneDevice.status === "Assigned" ? <Text color="success.600">Assigned</Text> : phoneDevice.status === "Inactive" ? <Text color="error.600">Inactive</Text> : "Available"} />
					{phoneDevice.user && (
						<Stat
							label="User"
							value={
								<Link as={NavLink} to={`/users/${phoneDevice.user._id}`}>
									{phoneDevice.user.name}
								</Link>
							}
						/>
					)}
				</Flex>
			</HStack>
		</ListItem>
	)
}
